import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React from "react";

const MuiCheckboxGroup = ({ choices, defaultValue, value, onChange }) => {
  const [selected, setSelected] = React.useState(value || defaultValue || []);

  React.useEffect(() => {
    if (value) setSelected(value);
  }, [value]);

  const handleChange = (id) => {
    const newValue = selected.includes(id)
      ? selected.filter((v) => v !== id)
      : [...selected, id];
    setSelected(newValue);
    onChange?.(newValue);
  };

  return (
    <FormGroup>
      {choices.map((choice) => (
        <FormControlLabel
          key={choice.id}
          control={
            <Checkbox
              checked={selected.includes(choice.id)}
              onChange={() => handleChange(choice.id)}
            />
          }
          label={choice.name}
        />
      ))}
    </FormGroup>
  );
};
export default MuiCheckboxGroup;
